import { render } from "./RegisterNewPerson.vue?vue&type=template&id=6562a51c"
import script from "./RegisterNewPerson.vue?vue&type=script&lang=js"
export * from "./RegisterNewPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__